import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListNavigation.css';

// Locale
import TabBarStep from '../../ListPlaceStep1/TabBarStep';

class ListNavigation extends React.Component {

  static propTypes = {
    step: PropTypes.number.isRequired,
    formPage: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  nextPage = (pathname) => {
    // This will be handled by the parent component or navigation
    // For now, we'll use a simple navigation approach
    if (typeof window !== 'undefined') {
      window.location.href = pathname;
    }
  };

  render() {
    const { step, formPage } = this.props;
    return (
      <div>
        <TabBarStep 
          step={step} 
          formPage={formPage} 
          nextPage={this.nextPage}
        />
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(ListNavigation));
